module.exports = require("userful-chronos-common-store/dist/calendar");